var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.fcce50d4fb2e992ac25faab1c9056213.svg#s';
                    var viewUrl = 'sprites.fcce50d4fb2e992ac25faab1c9056213.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 104 36',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };